export default "__VITE_ASSET__b9f0ed92__"